// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  padding: 0;
  width: 780px;
  margin: 20px auto;
}

li {
  display: inline;
}

.tn {
  margin: 2px 0px;
  box-shadow: #999 1px 1px 3px 1px;
  cursor: pointer;
}

.modal-content {
  width: 670px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/dispatches/dispatch-photos/dispatch-photos.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gCAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":["ul {\n  padding: 0;\n  width: 780px;\n  margin: 20px auto\n}\n\nli {\n  display: inline;\n}\n\n.tn {\n  margin: 2px 0px;\n  box-shadow: #999 1px 1px 3px 1px;\n  cursor: pointer\n}\n\n.modal-content {\n  width: 670px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
